import React from "react"
import ReactDOM from "react-dom"
import MessageTile from "./message-tile"

export default class MessageTileModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.data = JSON.parse(elem.dataset.model)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.render(<MessageTile {...self.data} />, self.elem)
  }
}
